import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
// eslint-disable-next-line import/no-extraneous-dependencies
import htmlToDraft from "html-to-draftjs";
import { useModal } from "../context/ModalContext";
import GlobalModal from "../components/GlobalModal";
import {
    AcceptanceTermsEditorWrapper,
    AcceptanceTermsEditorButtonWrapper,
} from "../styles/pages/AcceptanceTermsEditor";
import ButtonStyles from "../styles/components/ButtonStyles";
import AcceptanceTermsEditorService from "../service/Docente/AcceptanceTermsService";
import GenericUtils from "../utils/GenericUtils";

const AcceptanceTermsEditor: React.FC = () => {
    const { instance } = useMsal();
    const [editorContent, setEditorContent] = useState(
        EditorState.createEmpty()
    );
    const { openModal, isOpen, closeModal } = useModal();

    const exportHtml = () => {
        const rawContentState = convertToRaw(editorContent.getCurrentContent());
        return draftToHtml(rawContentState);
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const uploadImage = (file: Blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const dataURL = reader.result as string;
                const truncatedDataURL = `${
                    dataURL ? dataURL.substring(10, 30) : ""
                }...`; // set the maximum length of the truncated string
                resolve({
                    data: { link: dataURL },
                    link: { url: truncatedDataURL },
                });
            };
            reader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const getAcceptanceTerms = async () => {
        try {
            const response =
                await AcceptanceTermsEditorService.getAcceptanceTermsToEditor(
                    instance
                );
            const { data } = response;

            return data.replace(`<!DOCTYPE html [<!ENTITY nbsp "&#160;"]>`, "");
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return undefined;
        }
    };

    const setEditorInitialContent = async () => {
        const savedTerm = await getAcceptanceTerms();
        const blocksFromHtml = htmlToDraft(savedTerm);

        if (blocksFromHtml) {
            const { contentBlocks } = blocksFromHtml;

            const contentState =
                ContentState.createFromBlockArray(contentBlocks);

            const editorState = EditorState.createWithContent(contentState);
            setEditorContent(editorState);
        } else {
            setEditorContent(EditorState.createEmpty());
        }
    };

    const saveNewTerm = async () => {
        try {
            const markup = exportHtml();

            const response =
                await AcceptanceTermsEditorService.saveNewAcceptanceTerms(
                    instance,
                    markup
                );

            if (GenericUtils.isSuccessStatus(response)) {
                openModal();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    useEffect(() => {
        setEditorInitialContent();
    }, []);

    return (
        <AcceptanceTermsEditorWrapper>
            <Editor
                toolbarClassName="editorToolbar"
                wrapperClassName="editorWrapper"
                editorClassName="editor"
                editorState={editorContent}
                onEditorStateChange={(editorState) => {
                    setEditorContent(editorState);
                }}
                toolbar={{
                    image: {
                        previewImage: true,
                        uploadCallback: uploadImage,
                        alt: { present: true, mandatory: false },
                    },
                    options: [
                        "inline",
                        "blockType",
                        "fontSize",
                        "fontFamily",
                        "list",
                        "textAlign",
                        "link",
                        "image",
                        "history",
                    ],
                    inline: {
                        options: ["bold", "italic", "underline"],
                    },
                    FontFace: {
                        options: ["Arial", "Times New Roman"],
                    },
                }}
                localization={{
                    locale: "pt",
                }}
            />
            <AcceptanceTermsEditorButtonWrapper>
                <ButtonStyles.BtnPrimary onClick={saveNewTerm} name="salvar">
                    Salvar Termo de Aceite
                </ButtonStyles.BtnPrimary>
            </AcceptanceTermsEditorButtonWrapper>
            {/* <HtmlToReact htmlString={htmlString} /> */}
            {isOpen && (
                <GlobalModal
                    type="success"
                    successMessage="Novo termo de aceite salvo com sucesso!"
                    onClose={closeModal}
                />
            )}
        </AcceptanceTermsEditorWrapper>
    );
};

export default AcceptanceTermsEditor;
